// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  stripeKey: 'pk_test_s139iO3n0WLfQ4WQjw3FQXtl',
  firebase: {
    apiKey: 'AIzaSyAoAHqiJWULL-9OLeoQYvyF68Izf3r-OGI',
    authDomain: 'rent-hero-angular.firebaseapp.com',
    databaseURL: 'https://rent-hero-angular.firebaseio.com',
    projectId: 'rent-hero-angular',
    storageBucket: 'rent-hero-angular.appspot.com',
    messagingSenderId: '251023652879'
  },
  apiUrl : 'https://us-central1-rent-hero-angular.cloudfunctions.net/',
  sendgridKey : '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'
};



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/environments/environment.ts